import React from 'react';

const LetterIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="490"
    height="490"
    viewBox="0 0 25 25">
    <path fill="#F7FAFC" fillRule="evenodd" d="M21.778 3.006L21.592 3H3.413l-.183.005C1.827 3.09.69 4.165.522 5.53l-.016.172-.006.183v13.223l.005.182c.085 1.393 1.169 2.52 2.544 2.688l.173.016.185.006h18.18l.183-.005c1.403-.084 2.539-1.16 2.708-2.525l.016-.172.006-.183V5.892l-.005-.182c-.085-1.393-1.169-2.52-2.544-2.688l-.173-.016zm.991 3.143l.082.04v12.938l-.008.133c-.063.537-.47.969-.994 1.078l-.123.02-.133.006H3.394l-.133-.008c-.541-.063-.976-.466-1.086-.987l-.02-.123-.006-.131L2.23 6.15l10.236 8.425L22.77 6.15zm-.864-1.513l.032.089-9.338 7.703-.23-.011-9.275-7.781h18.81z"/>
  </svg>


);

export default LetterIcon;
